module.exports = __webpack_public_path__ + "static/media/icon-balanit-help.dc0ad090.svg";